import React from "react";
import "./Banner.css";

import technicianIcon from "../../assets/icons/Banner_icons/1.svg";
import responseIcon from "../../assets/icons/Banner_icons/2.svg";
import ratesIcon from "../../assets/icons/Banner_icons/3.svg";
import serviceIcon from "../../assets/icons/Banner_icons/4.svg";

const features = [
  {
    icon: technicianIcon,
    title: "Professional Technicians",
    description:
      "Experts delivering reliable service and maintenance every time.",
  },
  {
    icon: responseIcon,
    title: "Quick Response",
    description:
      "We have fully 24/7 customer support in our Business.",
  },
  {
    icon: ratesIcon,
    title: "Affordable Rates",
    description:
      "Quality service at prices that fit your budget.",
  },
  {
    icon: serviceIcon,
    title: "24/7 Service",
    description:
      "Round-the-clock support to keep your appliances running smoothly.",
  },
];

const FeatureCards = () => {
  return (
    <section className="features-section">
      {features.map((feature, index) => (
        <div className="feature-card" key={index}>
          <img
            src={feature.icon}
            alt={feature.title}
            className="feature-icon"
          />

          <h3>{feature.title}</h3>

          <p>{feature.description}</p>
        </div>
      ))}
    </section>
  );
};

export default FeatureCards;